import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faWhatsapp, faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faMobileAlt, faCameraRetro, faCalendarTimes, faBook, faMapMarkerAlt, faLock, faUser, faEnvelope, faComment, faNewspaper, faBookReader, faChalkboardTeacher, faFileSignature} from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import carousel from 'vue-owl-carousel'

library.add(faNewspaper, faMobileAlt,faCameraRetro,faCalendarTimes,faMapMarkerAlt,faLock, faBook, faUser, faEnvelope, faComment, faWhatsapp, faBookReader, faChalkboardTeacher, faFileSignature, faInstagram, faFacebook)

Vue.use(carousel)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
